import React, { Fragment, useReducer } from "react";
import ReactModal from "react-modal";
import { toast } from "react-toastify";

import PhoneInput from "react-phone-number-input";

const toastOptions = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};


const reducer = (state, action) => {
  switch (action.type) {
    case "fieldChanged": {
      return {
        ...state,
        [action.field]: action.value,
      };
    }
    case "openModal": {
      return {
        ...state,
        showModal: true,
        ...(action.payload || {}),
      };
    }
    case "openDeleteModal": {
      return {
        ...state,
        showDeleteModal: true,
        ...(action.payload || {}),
      };
    }
    case "closeModal": {
      return {
        ...state,
        showModal: false,
        showDeleteModal: false,
        _id: undefined,
        countryCode: "US",
        number: "",
        phoneType: "mobile",
      };
    }
    default:
      return state;
  }
};

const SingleProspectPhoneNumbersTable = (props) => {
  const { phoneNumbers = [], handleChange, handleToggleEdit, disabled = false } = props;
  const [primaryPhoneNumber, ...otherPhoneNumbers] = phoneNumbers;

  const initialState = {
    showModal: false,
    showDeleteModal: false,
    saving: false,
    _id: undefined,
    countryCode: "US",
    number: "",
    phoneType: "mobile",
  };

  const [state, dispatch] = useReducer(reducer, initialState);

  const handleAddPhoneNumber = (e) => {
    e.preventDefault();

    handleToggleEdit("phoneNumbers");
    dispatch({
      type: "openModal",
    });
  };

  const handleEditPhoneNumber = (e, index) => {
    e.preventDefault();

    const phoneNumber = phoneNumbers[index];
    if (!phoneNumber) {
      return;
    }

    handleToggleEdit("phoneNumbers");
    dispatch({
      type: "openModal",
      payload: phoneNumber,
    });
  };

  const handleDeletePhoneNumber = (e, index) => {
    e.preventDefault();

    const phoneNumber = phoneNumbers[index];
    if (!phoneNumber) {
      return;
    }

    handleToggleEdit("phoneNumbers");
    dispatch({
      type: "openDeleteModal",
      payload: phoneNumber,
    });
  };

  const handleCloseModal = () => {
    handleToggleEdit();
    dispatch({
      type: "closeModal",
    });
  };

  const handleUpdatePhone = async (e) => {
    e.preventDefault();

    if (!state.number || !state.countryCode) {
      return toast.error(
        "Please fill in all required fields and retry.",
        toastOptions,
      );
    }

    const phoneNumber = {
      _id: state._id,
      number: state.number,
      countryCode: state.countryCode,
      phoneType: state.phoneType,
    };

    dispatch({
      type: "fieldChanged",
      field: "saving",
      value: true,
    });
    await handleChange(
      state._id ?
        (phoneNumbers || []).map((item) => item._id === state._id ? phoneNumber : item) :
        [...(phoneNumbers || []), phoneNumber],
    );
    dispatch({
      type: "fieldChanged",
      field: "saving",
      value: false,
    });

    handleCloseModal();
  };

  const handleDeletePhoneNumberConfirm = async (e) => {
    e.preventDefault();

    if (!state._id) {
      return;
    }

    dispatch({
      type: "fieldChanged",
      field: "saving",
      value: true,
    });
    await handleChange((phoneNumbers || []).filter((item) => item._id !== state._id));
    dispatch({
      type: "fieldChanged",
      field: "saving",
      value: false,
    });

    handleCloseModal();
  };

  return (
    <Fragment>
      <tr className="heading-row">
        <td colSpan={3}>Primary Phone Number <span className="required">*</span></td>
        <td/>
      </tr>

      {primaryPhoneNumber && <tr>
        <td colSpan={3}>
          <PhoneInput
            value={primaryPhoneNumber.number}
            defaultCountry={primaryPhoneNumber.countryCode}
            disabled
          />
        </td>
        <td>
          <button
            className="base-button icon-button evo-blue"
            onClick={(e) => {
              handleEditPhoneNumber(e, 0);
            }}
            disabled={disabled}
          >
            <span className="material-icons">edit</span>
          </button>
        </td>
      </tr>}

      {otherPhoneNumbers.length > 0 && otherPhoneNumbers.map((phoneNumber, index) => (
        <Fragment key={phoneNumber._id}>
          <tr className="heading-row">
            <td colSpan={3}>Other Phone Number</td>
            <td/>
          </tr>

          <tr>
            <td colSpan={3}>
              <PhoneInput
                value={phoneNumber.number}
                defaultCountry={phoneNumber.countryCode}
                disabled
              />
            </td>
            <td>
              <button
                className="base-button icon-button evo-blue"
                onClick={(e) => {
                  handleEditPhoneNumber(e, index + 1);
                }}
                disabled={disabled}
              >
                <span className="material-icons">edit</span>
              </button>

              <button
                className="base-button icon-button btn-danger ml-2"
                onClick={(e) => {
                  handleDeletePhoneNumber(e, index + 1);
                }}
                disabled={disabled}
              >
                <span className="material-icons">delete</span>
              </button>
            </td>
          </tr>
        </Fragment>
      ))}

      <tr>
        <td colSpan={3}>
          <button
            className="mt-20 mb-20 action-button base-button base-blue-button"
            onClick={handleAddPhoneNumber}
            disabled={disabled}
          >
            Add Phone Number
          </button>
        </td>
        <td/>
      </tr>


      <ReactModal
        isOpen={state.showModal}
        shouldCloseOnEsc={false}
        shouldCloseOnOverlayClick={false}
        onRequestClose={handleCloseModal}
        style={{
          overlay: {
            zIndex: 999999,
            backgroundColor: "rgb(32 53 68 / 50%)",
          },
          content: {
            width: "auto",
            border: "none",
            overflowY: "scroll",
            maxHeight: "100vh",
            minWidth: "50vw",
            borderRadius: "0",
            boxShadow: "10px 10px 91px -17px rgb(0 0 0 / 25%)",
          },
        }}
        appElement={document.getElementById("app")}
      >
        <div className="modal-header base-modal">
          <h4>{state._id ? "Edit" : "Add"} Phone Number</h4>
        </div>

        <div className="modal-body base-modal prospect-phone-numbers-modal">
          <form onSubmit={handleUpdatePhone} className="w-100 base-form mt-20">
            <div
              className="form-group fb-100 ml-0"
            >
              <label className="phoneInputLabel" htmlFor="phone">
                Phone Number
              </label>
              <PhoneInput
                placeholder="Phone Number"
                value={state.number}
                name="number"
                onChange={(value) =>
                  dispatch({
                    type: "fieldChanged",
                    field: "number",
                    value: value,
                  })
                }
                onCountryChange={(value) =>
                  dispatch({
                    type: "fieldChanged",
                    field: "countryCode",
                    value: value,
                  })
                }
                defaultCountry={state.countryCode}
              />
            </div>


            <div className="w-100 mt-20 d-flex gap-20">
              <button className="base-button evo-blue flex-half" type="submit" disabled={state.saving}>
                Submit
              </button>

              <button className="base-button btn-danger flex-half" type="button" onClick={handleCloseModal}
                      disabled={state.saving}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      </ReactModal>

      <ReactModal
        isOpen={state.showDeleteModal}
        shouldCloseOnEsc={false}
        shouldCloseOnOverlayClick={false}
        onRequestClose={handleCloseModal}
        style={{
          overlay: {
            zIndex: 999999,
            backgroundColor: "rgb(32 53 68 / 50%)",
          },
          content: {
            width: "auto",
            padding: "40px",
            border: "none",
            maxWidth: "700px",
            maxHeight: "50%",
            borderRadius: "0",
            boxShadow: "10px 10px 91px -17px rgb(0 0 0 / 25%)",
          },
        }}
        appElement={document.getElementById("app")}
      >
        <div className="modal-header base-modal">
          <h4>Delete Phone Number</h4>
        </div>

        <div className="modal-body base-modal overflow-scroll">
          <div className="w-100 mt-20">
            Are you sure you want to delete this phone number from the prospect’s profile?<br/>
            This action cannot be undone.
          </div>

          <div className="w-100 mt-20 d-flex gap-20">
            <button className="base-button evo-blue flex-half" type="button" onClick={handleCloseModal}
                    disabled={state.saving}>
              Cancel
            </button>

            <button className="base-button btn-danger flex-half" type="button" onClick={handleDeletePhoneNumberConfirm}
                    disabled={state.saving}>
              Delete Phone number
            </button>
          </div>
        </div>
      </ReactModal>
    </Fragment>
  );
};

export default SingleProspectPhoneNumbersTable;
